import React from "react";
import { RouteObject } from "react-router-dom";
import { clientEndpoint } from "../../../routes/endpoint";
import { WithAuth } from "../../auth";
import { OutlineContainer } from "./outline";
import { ConceptReportContainer } from "./concept";
import { DownloadReportContainer } from "./download";
import { ExectiveReportContainer } from "./executive";
import { KeyMeasurementsReportContainer } from "./key-measurements";
import { OAReportContainer } from "./oa";
import { ResultByTargetReportContainer } from "./result-by-target";
import { SimulationContainer } from "./simulation";
import { latestVersion } from "../../../../../shared/version";

export const latestReportPages: RouteObject[] = [
	// report
	{
		path: clientEndpoint.outlineLatest,
		element: (
			<WithAuth isReportPage version={latestVersion}>
				<OutlineContainer />
			</WithAuth>
		),
	},
	{
		path: clientEndpoint.exectiveReportLatest,
		element: (
			<WithAuth isReportPage version={latestVersion}>
				<ExectiveReportContainer />
			</WithAuth>
		),
	},
	{
		path: clientEndpoint.resultByTargetReportLatest,
		element: (
			<WithAuth isReportPage version={latestVersion}>
				<ResultByTargetReportContainer />
			</WithAuth>
		),
	},
	{
		path: clientEndpoint.downloadReportLatest,
		element: (
			<WithAuth isReportPage version={latestVersion}>
				{(account) => <DownloadReportContainer {...account} />}
			</WithAuth>
		),
	},
	{
		path: clientEndpoint.conceptReportLatest,
		element: (
			<WithAuth doNotUseTab version={latestVersion}>
				<ConceptReportContainer />
			</WithAuth>
		),
	},
	{
		path: clientEndpoint.oaReportLatest,
		element: (
			<WithAuth isReportPage version={latestVersion}>
				<OAReportContainer />
			</WithAuth>
		),
	},
	{
		path: clientEndpoint.keyMeasurementsReportLatest,
		element: (
			<WithAuth isReportPage version={latestVersion}>
				<KeyMeasurementsReportContainer />
			</WithAuth>
		),
	},
	{
		path: clientEndpoint.simulationReportLatest,
		element: (
			<WithAuth isReportPage version={latestVersion}>
				{(account) => <SimulationContainer {...account} />}
			</WithAuth>
		),
	},
];
